import { render } from "./feedback-suggestions.vue?vue&type=template&id=57f5a722"
import script from "./feedback-suggestions.vue?vue&type=script&lang=js"
export * from "./feedback-suggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__